import QueryString from "qs";
import dynamic from "next/dynamic";
import { GetServerSideProps, NextPage } from "next";

const ItemPage = dynamic(() => import("@/Components/pages/ItemPage"));
const GhostPage = dynamic(() => import("@/Components/pages/GhostPage"));
const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

const components: Record<string, React.ComponentType<any>>  = {
  ItemPage: ItemPage,
  GhostPage: GhostPage,
  Itempage: ItemPage,
  //   ServicePage: ServicePage,
  //   TechnologyPage: TechnologyPage,
  //   IndustryPage: IndustryPage,
  //   StartUpPage: StartUpPage,
  //   BlogPage: BlogPage,
  //   CaseStudyPage: CaseStudyPage,
  //   TemplatePage: TemplatePages,
  //   UseCasePage: UseCasePage,
};

interface DynamicPageProps {
  component: string;
  apiResData: any;
  slug: string;
  listData: any[];
  referer: string;
  isNew: boolean;
  isMobile: boolean;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const referer = ctx?.req?.headers?.referer || "";
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }
  const slug = (ctx?.params?.slug as string) || "";

  if (slug.includes("request-for-quote-proposal")) {
    return {
      redirect: {
        permanent: false,
        destination: "/request-proposal",
      },
    };
  }
  if (slug === "home") {
    return {
      redirect: {
        permanent: true,
        destination: "/",
      },
    };
  }

  const res = await fetch(`${baseUrl}get-component-by-slug/${slug}?preview=on`);

  const component = await res.text();

  let apiRes = null;
  let apiResData = null;

  const query = QueryString.stringify(
    {
      publicationState: "preview",
      filters: {
        slug: {
          $eq: slug,
        },
        publishedAt: {
          $null: true,
        },
      },
      populate: "deep, 8",
    },
    {
      encodeValuesOnly: false,
    },
  );

  switch (component) {
    case "ItemPage":
    case "Itempage":
      apiRes = await fetch(`${baseUrl}pages?${decodeURIComponent(query)}`);
      break; // case "TemplatePage":apiRes = await fetch(`${baseUrl}template-pages?${decodeURIComponent(query)}`);break;
    case "GhostPage":
      apiRes = await fetch(
        `${baseUrl}ghost-pages?${decodeURIComponent(query)}`,
      );
      break;
    default:
      return {
        notFound: true,
      };
  }

  if (apiRes) {
    apiResData = await apiRes.json();
  }

  return {
    props: {
      component,
      apiResData,
      slug,
      referer,
    },
  };
};

const DynamicPage: NextPage<DynamicPageProps>  = ({ component, apiResData, slug, referer }) => {
  const NewComponent =  components[component];

  return (
    <div id="root">
      <div>
        {NewComponent && (
          <NewComponent slug={slug} data={apiResData} referer={referer} />
        )}
      </div>
    </div>
  );
};

export default DynamicPage;
